import * as React from 'react';

import { Feature } from '@commonTuna/react/objects/CompanyFeature';

import { useCompanyFeatureProviderContext } from '@app/components/UI/CompanyFeaturesSetter/CompanyFeaturesSetter';

interface CompanyFeatureAccessProps {
	children: React.ReactNode;
	feature: Feature | Array<Feature>;
	and?: boolean;
	or?: boolean;
}

export const CompanyFeatureAccess: React.FC<CompanyFeatureAccessProps> = (props: CompanyFeatureAccessProps) => {
	const {
		feature, and = true, or = false, children,
	} = props;

	const { checkFeatureAccess } = useCompanyFeatureProviderContext();
	const [isVisible, setIsVisible] = React.useState<boolean>(false);

	React.useEffect(() => {
		((checkFeatureAccess(feature) && and) || or) && setIsVisible(true);
	}, []);

	return <>{isVisible && children}</>;
};

export default CompanyFeatureAccess;
